import { TDepositAmountWidgetResult } from '../types';
import { IDepositAmountWidgetResponse } from '../../../../repositories/billing-accounts/v1/deposit-amount-widget';

export const mapResponse200 = (response: IDepositAmountWidgetResponse): TDepositAmountWidgetResult => {
  const { confirmationToken } = response;

  return confirmationToken!;
};
